import * as React from 'react';

type SelectOption = {
  value: string;
  text: string;
};

type SelectProps = Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'children'> & {
  options: SelectOption[];
  label: string;
};

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ options, label, name, ...props }, ref) => (
    <>
      <label htmlFor={name}>{label}</label>
      <select id={name} name={name} ref={ref} {...props}>
        {options.map(({ value, text }) => (
          <option key={value} value={value}>
            {text}
          </option>
        ))}
      </select>
    </>
  )
);

Select.displayName = 'Select';
